import Router from './router/Router'
import { ConfigProvider } from 'antd'
import './App.css'

function App() {
  return (
    <div className='App'>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#db585e'
          }
        }}
      >
        <Router />
      </ConfigProvider>
    </div>
  )
}

export default App
